import { FC } from 'react';

import { type FormikHelpers } from 'formik';
import { Formik } from 'formik';

import MultiDealsEditForm from '../forms/MultiDealsEditForm';
import {
  MULTI_DEALS_EDIT_FORM,
  MULTI_DEALS_EDIT_SCHEMA,
} from '../forms/schema';
import { useUpdateDeals } from '../hooks';

interface PROPS {
  dealIds: string[];
}

const FORM_INIT: MULTI_DEALS_EDIT_FORM = {
  tagId: [],
};

const EditDealsModal: FC<PROPS> = ({ dealIds }) => {
  const { mutate: editLeads } = useUpdateDeals();

  const onSubmit = (
    values: MULTI_DEALS_EDIT_FORM,
    { setSubmitting }: FormikHelpers<MULTI_DEALS_EDIT_FORM>,
  ) => {
    editLeads({ ...values, ids: dealIds });

    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
      validationSchema={MULTI_DEALS_EDIT_SCHEMA}
    >
      {() => <MultiDealsEditForm />}
    </Formik>
  );
};

export default EditDealsModal;
